module.exports = __webpack_public_path__ + "img/icon_Smoke-Free.4a816e2d.svg";